import { v5 } from "@credijusto/minerals";
import style from "./Security.module.scss";
import classNames from "classnames";
import EarthIcon from "../../../assets/icons/earth-fill.svg";
import Shield2icon from "../../../assets/icons/folder-shield-2-fill.svg";
import Incripted from "../../../assets/icons/file-code-fill.svg";
import FolderSecury from "../../../assets/icons/folder-lock-fill.svg";

const Security = () => {
  return (
    <section className={classNames(style.root, "mn-bg-secondary-one")}>
      <div className={style.container}>
        <div className={style.header}>
          <v5.Typography
            color="mn-secondary"
            font="serif"
            variant="h5"
            align="center"
            className={style.title}
          >
            Tu información está a salvo.
          </v5.Typography>
          <v5.Typography
            variant="body1"
            color="mn-secondary"
            align="center"
            className={style.subtitle}
          >
            La protegemos con los más altos estándares de ciberseguridad.
          </v5.Typography>
        </div>

        <div className={style.cardsContainer}>
          {/* Tarjeta 1 */}
          <div className={style.securityCard}>
            <div className={style.cardTitleContainer}>
              <img src={EarthIcon} alt="ISO 27001" className={style.cardIcon} />
              <v5.Typography
                color="mn-secondary"
                variant="body1"
                weight="bold"
                className={style.cardTitle}
              >
                ISO:27001
              </v5.Typography>
            </div>
            <v5.Typography variant="body2" className={style.cardContent}>
              Esta norma internacional garantiza la protección de tu
              información. Los centros de datos donde está localizada cuentan
              con esta certificación.
            </v5.Typography>
          </div>

          {/* Tarjeta 2 */}
          <div className={style.securityCard}>
            <div className={style.cardTitleContainer}>
              <img
                src={Incripted}
                alt="Encriptación"
                className={style.cardIcon}
              />
              <v5.Typography
                variant="body1"
                weight="bold"
                className={style.cardTitle}
              >
                Encriptación
              </v5.Typography>
            </div>
            <v5.Typography variant="body2" className={style.cardContent}>
              Se trata de un método de codificación de tus datos para que sólo
              las partes autorizadas puedan acceder a ellos.
            </v5.Typography>
          </div>

          {/* Tarjeta 3 */}
          <div className={style.securityCard}>
            <div className={style.cardTitleContainer}>
              <img
                src={Shield2icon}
                alt="Política de Privacidad"
                className={style.cardIcon}
              />
              <v5.Typography
                variant="body1"
                weight="bold"
                className={style.cardTitle}
              >
                Política de Privacidad
              </v5.Typography>
            </div>
            <v5.Typography variant="body2" className={style.cardContent}>
              Documento que explica cómo manejamos tu información, usada para
              propósitos de evaluación de crédito.
            </v5.Typography>
          </div>

          {/* Tarjeta 4 */}
          <div className={style.securityCard}>
            <div className={style.cardTitleContainer}>
              <img
                src={FolderSecury}
                alt="Límites de Acceso"
                className={style.cardIcon}
              />
              <v5.Typography
                variant="body1"
                weight="bold"
                className={style.cardTitle}
              >
                Límites de Acceso
              </v5.Typography>
            </div>
            <v5.Typography variant="body2" className={style.cardContent}>
              Lineamientos estrictos para que tu información sea consultada
              únicamente por personal autorizado.
            </v5.Typography>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Security;
